import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) =>
  createStyles({
    main: {
      border: '1px solid #F0F0F0',
      borderLeftWidth: 0,
      borderRightWidth: 0,
    },
    listItem: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      flexWrap: 'nowrap',
      margin: 0,
      marginLeft: theme.spacing(2),
      position: 'relative',
      '&::before': {
        content: '"\\2022"',
        position: 'absolute',
        left: -15,
      },
    },
    listItemWithoutName: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      flexWrap: 'nowrap',
      margin: 0,
      marginLeft: theme.spacing(2),
      position: 'relative',
    },
    label: {
      fontWeight: 600,
      whiteSpace: 'nowrap',
      fontSize: '1.2rem',
      position: 'relative',
    },
    listValue: {
      fontWeight: 400,
      whiteSpace: 'nowrap',
      fontSize: '1.2rem',
    },
  }),
)
